import Typography from "@portal/components/atoms/v2/typography";
import { useRobot } from "@portal/app/context/robotProvider";
import { MainBox } from "../components/mainBox";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { InfoBoxComponent } from "@portal/components/atoms/infoBox";
import { useSession } from "@portal/auth/client/SessionProvider";
import Checkbox from "@portal/components/atoms/v2/checkbox";
import { RobotFooterComponent } from "../components/footer";

export const DebtPage = ({ centerId, pageIndex, isDefaultLanguage }: IPageProps) => {
  const { session } = useSession();
  const { riskLevelRequest: request, setMoreValuesThanDebt, setNoCreditCardDebt } = useRobot();

  const isButtonDisabled = !request.moreValuesThanDebt || !request.noCreditCardDebt;

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const isLoggedIn = session?.status !== "unauthenticated";
  const redirect = !isLoggedIn && !isButtonDisabled;

  return (
    <>
      <MainBox>
        <Typography variant="Lead">{texts.PAGE_11_INFO}</Typography>

        <div className="flex mt-4">
          <Checkbox
            id="confirm_debt"
            text={texts.PAGE_11_DEBT_INFO}
            isChecked={request.moreValuesThanDebt ?? false}
            onChange={() => {
              setMoreValuesThanDebt(!(request.moreValuesThanDebt ?? false));
            }}
            largeTextOnly
          />
        </div>
        <div className="flex mt-4">
          <Checkbox
            id="confirm"
            text={texts.PAGE_11_CONFIRM}
            isChecked={request.noCreditCardDebt ?? false}
            onChange={() => {
              setNoCreditCardDebt(!(request.noCreditCardDebt ?? false));
            }}
            largeTextOnly
          />
        </div>
        {redirect && <InfoBoxComponent texts={[texts.PAGE_11_REDIRECT]} />}
      </MainBox>

      <RobotFooterComponent
        pageIndex={pageIndex}
        centerId={centerId}
        primaryButtonText={isLoggedIn ? texts.BUTTON_NEXT : texts.BUTTON_LOG_IN}
        secondaryButtonText={texts.BUTTON_BACK}
        disabled={isButtonDisabled}
      />
    </>
  );
};
